import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ButtonToolbar } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";

import { CheckboxButton, ArchiveButton, EditButton } from "../../../common";
import { DataTable } from "../../../common/DataTable";
import BasicGuaranteeFields from "./BasicGuaranteeFields";
import guaranteeTypes from "./enums/guaranteeTypes";
import guaranteeCategoryTypes from "./enums/guaranteeCategoryTypes";

import { DIRECTOR } from "../../../../utils/Roles";
import { GUARANTEES } from "../../../../utils/data/models";
import userHasAccess from "../../../../utils/userHasAccess";
import * as dataActions from "../../../../utils/data/dataActions";

class GuaranteesDataTable extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.archiveGuarantee = this.archiveGuarantee.bind(this);
    this.createEmptyGuaranteeModel = this.createEmptyGuaranteeModel.bind(this);
    this.createGuarantee = this.createGuarantee.bind(this);
    this.setCellClassNames = this.setCellClassNames.bind(this);
    this.toggleArchivedGuarantees = this.toggleArchivedGuarantees.bind(this);
    this.updateGuarantee = this.updateGuarantee.bind(this);
    this.getData = this.getData.bind(this);
  }

  componentWillMount() {
    this.props.dataActions.clearDataList(GUARANTEES);
  }

  archiveGuarantee({guaranteeId, isArchived, guaranteeType, category}) {
    this.props.dataActions
      .updateDataItem(GUARANTEES, { guaranteeId, isArchived: !isArchived, guaranteeType, category })
      .then(() => {
        this.getData(
          this.props.offset,
          this.props.limit,
          this.props.q,
          this.props.sortBy,
          this.props.filters
        );
      });
  }

  createEmptyGuaranteeModel() {
    const localizations = {};
    [...this.props.languages]
      .sort((a, b) => a.languageCode.localeCompare(b.languageCode))
      .map((l) => {
        localizations[l.languageCode] = {
          name: "",
          shortName: "",
          languageCode: l.languageCode,
        };
      });

    return {
      additionalCode: "",
      formulaDenominator: "1",
      guaranteeType: guaranteeTypes[0].value,
      taxableIncomeFederal: null,
      taxableIncomeQuebec: null,
      localizations,
    };
  }

  createGuarantee(values) {
    this.props.dataActions.createDataItem(GUARANTEES, values).then(() => {
      this.getData(
        this.props.offset,
        this.props.limit,
        this.props.q,
        this.props.sortBy,
        this.props.filters
      );
    });
  }

  setCellClassNames(guarantee) {
    return classNames({
      archived: guarantee.isArchived,
    });
  }

  toggleArchivedGuarantees() {
    const isArchivedFiltered = this.props.filters.includes(
      GUARANTEES.archiveFilter
    );
    const filters = isArchivedFiltered
      ? this.props.filters.filter(
          (filter) => filter != GUARANTEES.archiveFilter
        )
      : [...this.props.filters, GUARANTEES.archiveFilter];
    this.getData(
      this.props.offset,
      this.props.limit,
      this.props.q,
      this.props.sortBy,
      filters
    );
  }

  updateGuarantee(values) {
    this.props.dataActions.updateDataItem(GUARANTEES, values).then(() => {
      this.getData(
        this.props.offset,
        this.props.limit,
        this.props.q,
        this.props.sortBy,
        this.props.filters
      );
    });
  }

  getCols() {
    const { authLanguageCode } = this.props;
    return [
      {
        name: <FormattedMessage id="admin.guarantees.datatable.columns.name" />,
        key: "localizations.name",
        display: (guarantee) => (
          <span className={this.setCellClassNames(guarantee)}>
            {guarantee.localizations[authLanguageCode].name}
          </span>
        ),
        widthPct: 20,
      },
      {
        name: (
          <FormattedMessage id="admin.guarantees.datatable.columns.shortName" />
        ),
        key: "localizations.shortName",
        display: (guarantee) => (
          <span className={this.setCellClassNames(guarantee)}>
            {guarantee.localizations[authLanguageCode].shortName}
          </span>
        ),
        widthPct: 10,
      },
      {
        name: <FormattedMessage id="admin.guarantees.datatable.columns.code" />,
        key: "additionalCode",
        display: (guarantee) => (
          <span className={this.setCellClassNames(guarantee)}>
            {guarantee.additionalCode}
          </span>
        ),
        widthPct: 15,
      },
      {
        name: <FormattedMessage id="admin.guarantees.datatable.columns.category" />,
        key: "category",
        display: (guarantee) => (
          <FormattedMessage
              id={
                guaranteeCategoryTypes.find(
                  (type) => type.value == guarantee.category
                ).key
              }
            />
        ),
        widthPct: 15,
      },
      {
        name: <FormattedMessage id="admin.guarantees.datatable.columns.type" />,
        key: "guaranteeType",
        display: (guarantee) => (
          <span className={this.setCellClassNames(guarantee)}>
            <FormattedMessage
              id={
                guaranteeTypes.find(
                  (type) => type.value == guarantee.guaranteeType
                ).key
              }
            />
          </span>
        ),
        widthPct: 20,
      },
      {
        name: <FormattedMessage id="datatable.actions" />,
        display: (guarantee) => this.generateActionButtons(guarantee),
        widthPct: 20,
      },
    ];
  }
  renderFormatedMessage(icon) {
    return <span className="icon warning">{icon}</span>;
  }
  generateActionButtons(guarantee) {
    const { authLanguageCode } = this.props;
    return (
      <ButtonToolbar key={guarantee.guaranteeId}>
        <EditButton
          title={
            <FormattedMessage id="admin.guarantees.datatable.actions.edit" />
          }
          confirmationTitle={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
              {this.renderFormatedMessage}
            </FormattedMessage>
          }
          confirmationMessage={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
          }
          closeButtonKey="common.cancel"
          requiresCloseConfirmation={true}
          confirmOnClose={true}
          form={BasicGuaranteeFields}
          label={<FormattedMessage id="common.edit" />}
          data={
            this.props.active.guaranteeId == guarantee.guaranteeId
              ? this.props.active
              : null
          }
          getData={this.props.dataActions.getDataItem.bind(
            this,
            GUARANTEES,
            guarantee.guaranteeId,
            null,
            {
              "Accept-Language": this.props.languages.map(
                (l) => l.languageCode
              ),
            }
          )}
          editFunction={this.updateGuarantee}
        />
        {!guarantee.isArchived && (
        <ArchiveButton
          isArchived={guarantee.isArchived}
          disabled={!userHasAccess(DIRECTOR)}
          archivedName={guarantee.localizations[authLanguageCode].name}
          warningMessage={
            guarantee.isArchived ? (
              ""
            ) : (
              <FormattedMessage id="archiveButton.warningMessage.guarantees" />
            )
          }
          archiveFunction={this.archiveGuarantee.bind(
            null,
            guarantee
          )}
          label={
            guarantee.isArchived ? (
              <FormattedMessage id="common.unarchive" />
            ) : (
              <FormattedMessage id="common.archive" />
            )
          }
        />          
      )}
      </ButtonToolbar>
    );
  }

  generateAddButton() {
    return (
      <div>
        <CheckboxButton
          className="include-archived"
          id="archived"
          label={
            <FormattedMessage id="admin.guarantees.datatable.actions.includeArchivedGuarantees" />
          }
          checked={!this.props.filters.includes(GUARANTEES.archiveFilter)}
          onClick={this.toggleArchivedGuarantees}
        />
        <EditButton
          title={
            <FormattedMessage id="admin.guarantees.datatable.actions.add" />
          }
          confirmationTitle={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
              {this.renderFormatedMessage}
            </FormattedMessage>
          }
          confirmationMessage={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
          }
          closeButtonKey="common.cancel"
          requiresCloseConfirmation={true}
          confirmOnClose={true}
          label={<FormattedMessage id="common.add" />}
          add={true}
          form={BasicGuaranteeFields}
          data={this.createEmptyGuaranteeModel()}
          editFunction={this.createGuarantee}
        />
      </div>
    );
  }

  getData(offset, limit, q, sortBy, filters) {
    return this.props.dataActions.getDataList(
      GUARANTEES,
      offset,
      limit,
      q,
      sortBy,
      filters
    );
  }

  render() {
    return (
      <DataTable
        ref="dataTable"
        title={<FormattedMessage id="admin.guarantees.title" />}
        getData={this.getData}
        cols={this.getCols()}
        q={this.props.q}
        filters={this.props.filters}
        offset={this.props.offset}
        data={this.props.items}
        rowsPerPage={this.props.limit}
        totalRows={this.props.total}
        sortBy={this.props.sortBy}
        addButton={this.generateAddButton()}
      />
    );
  }
}

GuaranteesDataTable.propTypes = {
  active: PropTypes.object,
  authLanguageCode: PropTypes.string,
  dataActions: PropTypes.object,
  filters: PropTypes.array,
  guaranteesActions: PropTypes.object,
  items: PropTypes.array,
  q: PropTypes.string,
  languages: PropTypes.array.isRequired,
  limit: PropTypes.number,
  offset: PropTypes.number,
  sortBy: PropTypes.array,
  total: PropTypes.number,
  userLanguage: PropTypes.string,
  guarantees: PropTypes.array,
};

GuaranteesDataTable.defaultProps = { limit: 10 };

function mapStateToProps(state) {
  const data = state.data.guarantees || {};
  const pagination = data.pagination || {};
  return {
    active: data.active || {},
    authLanguageCode: state.auth.user.languageCode,
    filters: data.filters || [GUARANTEES.archiveFilter],
    limit: pagination.limit || 100,
    offset: pagination.offset || 0,
    q: data.q,
    sortBy: data.sortBy || ["localizations.name:asc"],
    total: pagination.totalCount || 0,
    items: data.items || null,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GuaranteesDataTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/guarantees/GuaranteesDataTable.js